import { OrdersProvider } from 'contexts/orders.context';
import React from 'react';
import OrdersContent from './content';

const OrdersLayout = () => {
  return (
    <OrdersProvider>
      <OrdersContent />
    </OrdersProvider>
  );
};

export default OrdersLayout;
